import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { PureComponent } from 'react';
import Years from './Years';
import ClassNames from 'classnames';
var DecadeView = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(DecadeView, _PureComponent);
  function DecadeView() {
    return _PureComponent.apply(this, arguments) || this;
  }
  var _proto = DecadeView.prototype;
  _proto.renderYears = function renderYears() {
    return /*#__PURE__*/React.createElement(Years, this.props);
  };
  _proto.render = function render() {
    var keyboradHighlight = this.props.keyboradHighlight;
    var className = ClassNames("ap-calendar__decade-view", {
      "keyboard-date-view-inner-highlight": keyboradHighlight
    });
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, this.renderYears());
  };
  return DecadeView;
}(PureComponent);
export { DecadeView as default };